<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-application-cog
      </v-icon> App Modules
    </h2>
    <br>
    <v-col
      class="text-right"
    >
      <v-btn
        color="#FF3700"
        @click="showAssignAppForm = true"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        App Module
      </v-btn>
      <v-btn
        color="#37474F"
        class="text-right"
        :disabled="!isOrgAppModuleExist"
        @click="showAddModuleForm = true"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        Module
      </v-btn>
    </v-col>
    <v-card
      v-if="!isOrgAppModuleExist"
      color="#CFD8DC"
      class="app-modules"
    >
      <p class="my-alert-style">
        No App Modules Found.
      </p>
    </v-card>
    <v-tabs
      v-model="tab"
      color="#FF3700"
      background-color="#ECEFF1"
    >
      <v-tab
        v-for="(item, index) in orgAppModules"
        :key="index"
        @click="fetchLatestOrgModulesList(item.name)"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>
    <assign-app-module
      v-if="showAssignAppForm"
      @closed="showAssignAppForm = false"
      @success="fetchOrganizationDetails"
    />
    <create-organization-module
      v-if="showAddModuleForm"
      @get-organization-module-details="fetchLatestOrgModulesList"
      @closed="showAddModuleForm = false"
    />
    <organization-module-details
      v-if="isOrgAppModuleExist"
      ref="orgModules"
    />
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
<script>

  import AssignAppModule from './AssignAppModule.vue';
  import OrganizationModuleDetails from './OrganizationModuleDetails.vue';
  import CreateOrganizationModule from 'src/views/dashboard/organizations/CreateOrganizationModule.vue';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'OrgAppModules',
    components: {
      'assign-app-module': AssignAppModule,
      'organization-module-details': OrganizationModuleDetails,
      'create-organization-module': CreateOrganizationModule,
      'centre-spinner': spinner,
    },
    data: () => ({
      tab: null,
      orgAppModules: [],
      showAssignAppForm: false,
      currentActiveTab: '',
      showAddModuleForm: false,
      loading: false,
    }),
    computed: {
      organizationDetails () {
        return this.$store.getters['organizations/getOrganizationDetails'];
      },
      isOrgAppModuleExist () {
        if (Object.keys(this.organizationDetails).length > 0 && this.organizationDetails.app_modules.length > 0) {
          return true;
        }
        return false;
      },
    },
    async mounted () {
      this.loading = true;
      await this.loadAppModules();
      this.loading = false;
    },
    methods: {
      async loadAppModules () {
        this.loading = true;
        if (this.isOrgAppModuleExist === true) {
          this.orgAppModules = this.organizationDetails.app_modules;
          this.currentActiveTab = this.orgAppModules[0].name;
          this.$refs.orgModules.fetchOrganizationModuleDetails(this.currentActiveTab);
          this.loading = false;
          return;
        }
        this.loading = false;
      },
      async fetchLatestOrgModulesList (val) {
        this.$refs.orgModules.fetchOrganizationModuleDetails(val);
      },
      async fetchOrganizationDetails () {
        this.loading = true;
        const organizationlId = this.$route.params.organizationId;
        await this.$store.dispatch('organizations/fetchOrganizationDetails', {
          organizationId: organizationlId,
        }).then(response => {
          this.loadAppModules();
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
  margin-left: 20px;
}
.my-tabs-background-style {
    background-color: #ECEFF1 !important;
}
.app-modules {
  padding-top: 50px;
  padding-bottom: 50px;
}
.my-alert-style {
  font-size: 18px;
  font-weight: bold;
  color: #C62828;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: center;
}
</style>
